import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableRateShopperDeliverByDate = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableRateShopperDeliverByDate);
};
